import styled from 'styled-components';
import { publicMarginBottom } from '@whitelabel/helpers/style';
import FormikFormField from '@whitelabel/xcover-shared/components/FormikFormField';

const StyledFormikFormField = styled(FormikFormField)`
  ${publicMarginBottom}
`;

export default StyledFormikFormField;
